import { default as Modal } from "./AbstractModal";
import { gsap, SplitText } from "gsap/all";
import { html } from "../utils/environment";
gsap.registerPlugin(SplitText);

const CLASS = "u-anim-text";
export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = "has-news-open";

    constructor(m) {
        super(m);

        // Binding
        this.onResizeSplitBind = this.onResizeSplit.bind(this);
        this.onScrollBind = this.onScroll.bind(this);
        this.closeBind = (e) => {
            if (e.key === "Escape") {
                this.onBack();
            }
        };

        // Events
        this.events = {
            click: {
                close: "onBack",
                scrollable: "onBack",
                anim: "onBack",
            },
        };

        // UI
        this.$scrollable = this.$("scrollable")[0];
        this.$anim = this.$("anim")[0];

        // No split as default
        this.splitType = "lines";

        // Data
        this.topThreshold = 40;

        //
        this.backTarget = window.location.pathname;
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$scrollable.addEventListener("scroll", this.onScrollBind);
    }

    unbindEvents() {
        this.$scrollable.removeEventListener("scroll", this.onScrollBind);
    }

    bindSplitEvents() {
        window.addEventListener("resizeEnd", this.onResizeSplitBind);
    }

    unbindSplitEvents() {
        window.removeEventListener("resizeEnd", this.onResizeSplitBind);
    }

    ///////////////
    // Callbacks
    ///////////////
    onInit() {}

    onDestroy() {
        this.unbindSplitEvents();
        this.unbindEvents();
    }

    onClose(args) {}

    onOpen(args) {
        this.show();
    }

    onBack() {
        if (html.classList.contains(this.activeClass)) {
            this.hide();
            this.call('goTo', { url: this.backTarget, transition: 'newsDetails' }, 'Load')
        }
    }

    onResizeSplit() {
        // this.initSplits();
    }

    onScroll() {
        if (this.$scrollable.scrollTop > this.topThreshold && !this.hasScroll) {
            this.hasScroll = true;
            this.el.classList.add("has-scroll");
        } else if (
            this.$scrollable.scrollTop < this.topThreshold &&
            this.hasScroll
        ) {
            this.hasScroll = false;
            this.el.classList.remove("has-scroll");
        }
    }

    show() {
        this.hasScroll = false;
        this.el.classList.remove("has-scroll");

        gsap.delayedCall(0.5, () => {
            this.$scrollable.scrollTop = 0;

            requestAnimationFrame(() => {
                // this.initSplits();
                this.bindEvents();
                this.bindSplitEvents();
                this.el.classList.add("is-show");

                gsap.delayedCall(0.3, () => {
                    this.$anim.classList.add("is-active");
                });
            });
        });
    }

    hide() {
        this.el.classList.remove("is-show");
        this.$anim.classList.remove("is-active");

        gsap.delayedCall(0.3, () => {
            this.unbindSplitEvents();
        });

        this.unbindEvents();
    }

    initSplits() {
        const $title = this.el.querySelector(".u-anim-modal-split-reveal");

        // Splt text
        this.split = new SplitText($title, {
            type: this.splitType,
            linesClass: `${CLASS}_line`,
            tag: "span",
        });

        // Add number of lines props to container
        const totalLines = this.split.lines.length;
        $title.style.setProperty("--anim-text-total-lines", totalLines);

        // Add line index to each lines
        this.split.lines.forEach(($line, i) => {
            $line.style.setProperty("--anim-text-line-index", i);

            const lineContent = $line.innerHTML;
            const lineSpan = "<span>" + lineContent + "</span>";
            $line.innerHTML = lineSpan;
        });
    }

    updateBackTarget(url) {
        this.backTarget = url
    }
}
